import _ from 'lodash';

import { createSelector } from 'reselect';

import { selectType, selectKind } from '../location/selectors';
import { currentCourseSelector } from '../Courses/selectors';
import { selectCurrentPage } from '../Pages/selectors';
import { selectCurrentInstitution } from '../Institutions/selectors';

import { selectCurrentProfileUserProfileName } from '../Users/CurrentProfileUser/selectors';
import {
  ROUTE_USER_PROFILE_PAGE,
  ROUTE_MARKETING_PAGE,
  ROUTE_SSO,
  ROUTE_INSTITUTION_ADMIN,
  ROUTE_CREATE_COURSE_PAGE,
  ROUTE_CERTIFICATE_VERIFICATION_PAGE,
  ROUTE_COURSE_CERTIFICATION,
  ROUTE_ACCOUNTS_SUBSCRIPTIONS,
  ROUTE_COURSE_PAGE,
  ROUTE_SSR_TEST,
  ROUTE_PAYMENT_DETAILS_PAGE,
  ROUTE_HOMEPAGE,
  ROUTE_PARTNERS_LISTING_PAGE,
  ROUTE_COURSES,
} from '../routeActions';
import { DEFAULT_PAGE_TITLE } from '../constants';
import { PROFILE_PAGE_DEFAULT } from '../../web/containers/ProfilePage/consts';
import { selectPage } from '../BasePage/selectors';
import { selectIsTrialSubscriptionPurchase } from '../PaymentTransaction/selectors';

const pageCourseAndInstitution = (currentPage, course, institution) => {
  const titleParts = [];
  const title = currentPage.get('title');
  const courseName = course.get('name');
  if (title) {
    titleParts.push(title);
  }
  if (courseName) {
    titleParts.push(courseName);
  }
  if (institution) {
    titleParts.push(institution.get('name'));
  }
  titleParts.push('OpenLearning');
  return titleParts.join(' - ');
};

export const coursePageTitle = (currentPage, course, institution) => {
  if (!currentPage || !course || !currentPage) {
    return null; // for some reason, course is null for some course pages, so unfortunately we need this clause here
  }
  return pageCourseAndInstitution(currentPage, course, institution);
};

export const selectPageTitle = createSelector(
  [
    selectType,
    selectPage,
    selectCurrentPage,
    currentCourseSelector,
    selectCurrentInstitution,
    selectKind,
    selectCurrentProfileUserProfileName,
    selectIsTrialSubscriptionPurchase,
  ],
  (
    routeActionType,
    userProfilePage,
    currentPage,
    course,
    currentInstitution,
    routeActionKind,
    currentProfileUserProfileName,
    isTrialSubscriptionPurchase
  ) => {
    switch (routeActionType) {
      case ROUTE_SSR_TEST: {
        return 'SSR test :)';
      }
      case ROUTE_HOMEPAGE: {
        return 'Online courses - access to free and private courses on OpenLearning';
      }
      case ROUTE_PARTNERS_LISTING_PAGE: {
        return 'Top education providers delivering world class online courses with OpenLearning';
      }
      case ROUTE_COURSES: {
        return 'Online courses - access to free and private courses on OpenLearning';
      }
      case ROUTE_USER_PROFILE_PAGE:
        // page title shows profile name instead of full name because user info is requested
        // asynchronously, so the full name is not available during routing
        return `${_.upperFirst(
          userProfilePage || PROFILE_PAGE_DEFAULT
        )} - ${currentProfileUserProfileName} - OpenLearning`;

      case ROUTE_PAYMENT_DETAILS_PAGE: {
        if (isTrialSubscriptionPurchase) {
          return 'Start your 30 day free trial';
        }
        return 'Complete your purchase';
      }

      case ROUTE_CREATE_COURSE_PAGE: {
        return 'Create an online course in minutes using OpenLearning!';
      }

      // TODO: assign page titles to these routes
      case ROUTE_COURSE_PAGE:
        return coursePageTitle(currentPage, course, currentInstitution);
      case ROUTE_SSO:
      case ROUTE_INSTITUTION_ADMIN:
      case ROUTE_CERTIFICATE_VERIFICATION_PAGE:
      case ROUTE_MARKETING_PAGE:
      case ROUTE_COURSE_CERTIFICATION:
      case ROUTE_ACCOUNTS_SUBSCRIPTIONS:
        return null; // this means the code in newBase.html's title block will be determine the title.

      default: {
        if (routeActionKind === 'load') {
          // i.e. state.location.kind - `load` is the initial page load, not SPA which is `push` or `replace` or `pop`
          return null; // Don't change the title to the fallback after initial page load
        } else {
          return DEFAULT_PAGE_TITLE; // Fallback for SPA transitions where the frontend doesn't know the title yet
        }
      }
    }
  }
);
